<template>
  <div class="product" :class="[{ 'column' : isColumn }, { 'row' : !isColumn }]">
    <div class="product_image">
      <img :src="loadImage()" :alt="product.giftProductName">
    </div>
    <div class="product_contents">
      <h3 class="product_title ab">{{ product.giftProductName }}</h3>
      <!-- <p class="product_text a6">内容量: 1本</p> -->
      <div class="mt10"></div>
      <BaseBtn v-if="isBtnShow" :btnText="'この製品を選ぶ'" :type="'blue'" @onClick="$emit('productClick')" class="product_btn" />
    </div>
  </div>
</template>

<script>
import BaseBtn from "@/components/common/BaseBtn.vue";
import Config from '@/config/config';


export default {
  components: {
    BaseBtn,
  },
  props: {
    isBtnShow: {
      type: Boolean,
      default: true
    },
    isColumn: {
      type: Boolean,
      default: true
    },
    product: {
      type: Object,
      default: () => ({})
    },
  },
  date() {
    return {
      noImagePath: require('@/assets/images/products/50038.png'),
      imagePath: '' // 初期値を設定
    }
  },
  methods: {
    imageError(e) {
      e.target.src = this.noImagePath;
    },
    loadImage() {
      const imageUrl = Config.APIURL + this.product.giftProductImagePath;
      return imageUrl;
    }
  }
}
</script>

<style lang="css" scoped>
.product {
  border: 3px solid #EEEEEE;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
}

.product.column {
  flex-direction: column;
}

.product.row {
  flex-direction: row;
}

.product_contents {
  display: flex;
  flex-direction: column;
}
.product_title {
  font-size: 14px;
}
.product_text {
  font-size: 12px;
}

.product_btn {
  font-size: 14px;
  padding: 3px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/keepgoing/Product.vue